const IssueStatusColorEnum = Object.freeze({
  0: '#2F4CB4',
  1: '#FDB03D',
  2: '#25B771'
});

export default IssueStatusColorEnum;
